<template>
  <div class="login">
    <div class="bg" id="bg">
      <img src="./assets/images/bg.png" alt="">
      <div class="login-reg" :style="{top:bgHeight + 'px'}">
        <div class="logo">
          <img src="./assets/images/logo.png" alt="">
        </div>

        <div class="btns">
          <div class="btn login-btn" @click="changeTab" :class="isLogin?'active':''">登录</div>
          <div class="btn reg-btn" @click="changeTab" :class="!isLogin?'active':''">注册</div>
        </div>

        <div class="container-box">
          <!-- 注册 -->
          <div class="box" v-if="!isLogin && !forgetPwd">
            <div class="title">用户注册</div>
            <div class="form">
              <div class="item">
                <input type="text" v-model="formReg.username" placeholder="请输入手机号">
              </div>
              <div class="item1" style="display: flex;height:30px"  >
                  <span>设置密码：</span> 
                  <span>
                    <van-radio-group v-model="formReg.choosePwd" direction="horizontal" >
                      <van-radio name="输入密码">输入密码</van-radio>
                      <van-radio name="随机密码">随机密码</van-radio>
                    </van-radio-group>
                  </span>
              </div>
              <div class="item1" style="display:flex;margin-bottom:5px"  >
                  <span style="color:green;font-size:14px;" v-if="formReg.choosePwd =='随机密码'" >随机码将发送到您的手机，请注意查收</span> 
              </div>
              <div class="item code"  v-if="formReg.choosePwd =='随机密码'">
                <input
                  type="text"
                  v-model="formReg.code"
                  placeholder="请输入验证码"
                />
                <div class="getCode" @click="sendCode">
                  <span style="margin-right: 5px; color: #d8d8d8">| </span>
                  {{ regSendCodeTextTwo }}
                </div>
              </div>
              <div class="item code"  v-if="formReg.choosePwd =='输入密码'">
                <input
                  type="text"
                  v-model="formReg.code"
                  placeholder="请输入验证码"
                />
                <div class="getCode" @click="sendCode">
                  <span style="margin-right: 5px; color: #d8d8d8">| </span>
                  {{ regSendCodeText }}
                </div>
              </div>
              <div class="item" v-if="formReg.choosePwd =='输入密码'">
                <input
                  type="text"
                  v-model="formReg.password"
                  placeholder="请输入密码"
                />
              </div>
              <div class="item" v-if="formReg.choosePwd =='输入密码'">
                <input
                  type="text"
                  v-model="formReg.password1"
                  placeholder="请确认密码"
                />
              </div>
            </div>
            <div class="check">
              <van-checkbox
                checked-color="#00D385"
                icon-size="14px"
                class="check-box"
                v-model="formReg.checked"
                shape="square"
              />
              <div class="text">
                我已阅读并接受
                <a
                  style="color: green; cursor: pointer"
                  target="_blank"
                  @click="gotoDetail(2)"
                  >《用户注册协议》</a
                >
                <a
                  style="color: green; cursor: pointer"
                  target="_blank"
                  @click="gotoDetail(1)"
                  >《隐私政策声明》</a
                >
              </div>
            </div>
            <div class="syb-btn" v-if="formReg.choosePwd =='输入密码'" @click="register">确认注册</div>
             <div class="syb-btn" v-if="formReg.choosePwd =='随机密码'" @click="registerTwo">确认注册</div>
          </div>
          <!-- 登录 -->
          <div class="box" v-if="isLogin && !forgetPwd">
            <div class="title">用户登录</div>
            <div class="logintype">
              <div class="btn" @click="isLoginByCode= !isLoginByCode" :class="!isLoginByCode?'active':''">密码登录</div>
              <div class="btn" @click="isLoginByCode= !isLoginByCode" :class="isLoginByCode?'active':''">验证码登录</div>
            </div>
             <div class="form"  v-if="isLoginByCode">
              <div class="item">
                <input
                  type="text"
                  v-model="loginForm.mobile"
                  placeholder="请输入手机号"
                />
              </div>
              <div class="item code">
                <input
                  type="text"
                  v-model="loginForm.code"
                  placeholder="请输入验证码"
                />
                <div class="getCode" @click="sendCode2">
                  <span style="margin-right: 5px; color: #d8d8d8">| </span>
                  {{ regSendCodeLogin }}
                </div>
              </div>
               <div class="item code">
                <input
                  type="text"
                  v-model="loginForm.checkCode"
                  placeholder="请输入图形验证码"
                />
                <div class="getCode">
                  <span>
                    <img :src="this.img" alt="" @click="acquireVerification">
                  </span>
                </div>
              </div>
              <div class="item1" style="display: flex">
                <span
                  @click="forgetPwd = true"
                  style="
                    font-size: 12px;
                    color: rgba(0, 211, 133, 1);
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 500;
                    margin-left: 10px;
                  "
                  >忘记密码？</span
                >
              </div>
               <div class="syb-btn" @click="submitByCode">
              登录
            </div>
            </div>

             <div class="form"  v-if="!isLoginByCode">
              <div class="item">
                <input
                  type="text"
                  v-model="loginFormTwo.mobile"
                  placeholder="请输入手机号"
                />
              </div>
              <div class="item code">
                <input
                  type="text"
                  v-model="loginFormTwo.checkCode"
                  placeholder="请输入图形验证码"
                />
                <div class="getCode">
                  <span>
                    <img :src="this.img" alt="" @click="acquireVerification">
                  </span>
                </div>
              </div>
              <div class="item">
                <input
                  type="text"
                  v-model="loginFormTwo.password"
                  placeholder="请输入密码"
                />
              </div>
              <div class="item1" style="display: flex">
                <span
                  @click="forgetPwd = true"
                  style="
                    font-size: 12px;
                    color: rgba(0, 211, 133, 1);
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 500;
                    margin-left: 10px;
                  "
                  >忘记密码？</span
                >
              </div>
               <div class="syb-btn" @click="submit">
              登录
            </div>
            </div>
          </div>
          <!-- 找回密码 -->
          <div class="box" v-if="forgetPwd">
            <div class="title">找回密码</div>
            <div class="form">
              <div class="item">
                <input type="text" v-model="forgetForm.mobile" placeholder="请输入手机号">
              </div>
              <div class="item code">
                <input type="text" v-model="forgetForm.code" placeholder="请输入验证码">
                <div class="getCode"  @click="sendCode1"> <span style="margin-right:5px;color:#D8D8D8">| </span> {{regSendCodeText}}</div>
              </div>
              <div class="item">
                <input type="text" v-model="forgetForm.password" placeholder="请输入新密码">
              </div>
            </div>

            <div class="syb-btn" @click="resetPwd">完成</div>
            <div class="back"  style="    display: flex;"><span style="font-size:12px;color:rgba(0,211,133,1);font-family:PingFangSC-Regular,PingFang SC;font-weight:500;line-height:30px" @click="forgetPwd=false;isLogin=true">返回登录</span></div>
          </div>
        </div>

      </div>
    </div>

    <div class="beian">
      <p>保险业务经营许可证：260538000000800希望天源保险经纪有限公司</p>
      <p>版权所有 ©2020 希望保 蜀ICP备20014362号-2</p>
    </div>
    <van-dialog v-model="regPdfFlag" show-cancel-button :width="pageWidth">
      <div>
        <pdf 
        :src="regPdfFUrl"
        :page="currentPage" 
        @num-pages="pageCount=$event" 
        @page-loaded="currentPage=$event"
        @loaded="loadPdfHandler"></pdf>
        <p class="arrow" style="display: flex;justify-content: space-evenly;align-items: center;height: 50px;">
          <span @click="changePdfPage(0)" class="turn" :style="{color:currentPage==1?'gray':''}">Preview</span>
          {{currentPage}} / {{pageCount}}
          <span @click="changePdfPage(1)" class="turn" :style="{color: currentPage==pageCount?'gray':''}">Next</span>
          </p>
      </div>
    </van-dialog>

    <div class="userBox" v-if="userBool">
      <div class="userCenter">
        <div class="title">{{ setIndex == 2?'用户注册协议':'隐私政策声明' }}</div>
        <div id="wordView" v-html="wordText" ></div>
        <div class="btn" @click="userBool = false">确定</div>
      </div>
    </div>
    

  </div>
</template>

<script>
import { Dialog,Checkbox, RadioGroup , Radio, } from 'vant';
import pdf from 'vue-pdf'
import { mapActions } from "vuex";
import axios from "axios";
import CryptoJS from 'crypto-js';
import qs from 'qs'
import wechatService from '@/services/request/wechatService.js'
import logoImg from './assets/images/logo.png'
import mammoth from "mammoth";

import Vue from 'vue'
Vue.use(Dialog)

export default {
  name: 'Login',
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Dialog.name]:Dialog,
    pdf
    
  },
  data() {
    return {
      userBool:false,
      wordText:"",
      setIndex:2,
      logoImg:logoImg,
      pageWidth:window.innerWidth -10,
      bgHeight:0,
      regCheck:false,
      isLogin:this.$route.query.reg?false:true,
      isLoginByCode:false,
      forgetPwd:false,
      img:'',
      loginForm:{
        mobile:'',
        password:'',
        code:'',
        checkCode:"",
        uuid:''
      },
      loginFormTwo: {
        mobile: "",
        password: "",
        code: "",
        checkCode:"",
        uuid:''
      },
      regSendCodeText:'获取动态码',
      regSendCodeLogin:"获取动态码",
      regSendCodeTextTwo:"获取动态码",
      formReg: {
        username: "",
        password: "",
        password1:"",
        code: "",
        checked:false,
         choosePwd:'输入密码',
        uuids:""
      },
      forgetForm:{
        mobile:'',
        code:'',
        password:''
      },
      unionId:'',
      openId:'',
      regPdfFlag:false,
      regPdfFUrl:'',
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: 'pdf', // 文件类型
    }
  },
  mounted() {
    this.initStyle()
    this.acquireVerification()
    if(location.href.indexOf('http://localhost') != -1){

    }else if(this.$page.isInWechat){
      wechatService.auth(0, ({
      openid, unionid
      }) => {
        if(!!openid && !!unionid) {
          this.unionId = unionid
          this.openId = openid
          this.shareConfig()     
        }
      }, false)
    }
    
    document.title = '希望保邀请注册'
  },
  methods: {
    ...mapActions("d2admin/account", ["login"]),
    changePdfPage (val) {
        // console.log(val)
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
          // console.log(this.currentPage)
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
          // console.log(this.currentPage)
        }
      },

    // pdf加载时
    loadPdfHandler (e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    preview(url, filename){
      this.regPdfFUrl = pdf.createLoadingTask(url)
      // this.regPdfFUrl=fileURL
        this.regPdfFlag=true
        // this.getBlob(url,  (blob)=> {
        //     this.previewAS(blob, filename);
        // });
    },
    //url:文件地址 filename:想要修改为的名称
    download(url, filename) {
        this.getBlob(url,  (blob)=> {
            this.saveAs(blob, filename);
        });

    },

    getBlob(url, cb) {

        var xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);

        xhr.responseType = 'blob';

        xhr.onload = function () {

        if (xhr.status === 200) {

        cb(xhr.response);

        }

        };

        xhr.send();

    },

    previewAS(blob, filename){
        if(filename.indexOf('pdf') != -1){
            blob = new Blob([blob], {
                type: 'application/pdf;chartset=UTF-8'
            })
        }else{
            blob = new Blob([blob], {
                type: 'application/word;chartset=UTF-8'
            })
        }

        var fileURL = URL.createObjectURL(blob)
        this.regPdfFUrl=fileURL
        this.regPdfFlag=true
        // window.open(fileURL)
        // var el = document.createElement("a");
        // document.body.appendChild(el);
        // el.href = fileURL; //url 是你得到的连接
        // el.target = '_new'; //指定在新窗口打开
        // el.click();
        // document.body.removeChild(el)
    },

    saveAs(blob, filename) {

        if (window.navigator.msSaveOrOpenBlob) {

        navigator.msSaveBlob(blob, filename);

        } else {

        var link = document.createElement('a');

        var body = document.querySelector('body');

        link.href = window.URL.createObjectURL(blob);

        link.download = filename;

        // fix Firefox

        link.style.display = 'none';

        body.appendChild(link);

        link.click();

        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);

        };

    },
    shareConfig(){
      let wxShareConfig = {
        title: '希望保邀请注册',
        desc: '一个为企业降低风险的平台',
        imgUrl: 'https://fimage.huaxiyou.cc/common/ext/icon.png',
        link: location.href,
      };
      console.log('wxShareConfig',wxShareConfig)
      wechatService.jsapi(0, wxShareConfig, ['onMenuShareTimeline', 'onMenuShareAppMessage'])
    },
    initStyle(){
      // let el = document.getElementById('bg')
      let width = window.innerWidth
      let height = width*0.59
      this.bgHeight = height/2
      console.log(this.bgHeight)
    },
    changeTab(){
      this.isLogin = !this.isLogin
      this.forgetPwd = false
    },
  submit() {
      if (this.loginFormTwo.mobile == "") {
        this.$toast.fail("请输入手机号");
        return;
      }
      if (this.loginFormTwo.password == "") {
        this.$toast.fail("请输入密码");
        return;
      }
      if (this.loginFormTwo.checkCode == "") {
        this.$toast.fail("请输入图形验证码");
        return;
      }
      this.login({
        // vm: this,
        mobile: this.loginFormTwo.mobile,
        password: this.loginFormTwo.password,
        randomString:this.loginFormTwo.checkCode,
        uuids:this.loginFormTwo.uuid,
        state:0,
        VerificationCode:this.loginFormTwo.code
      })
        .then((res) => {
          if (res.code == 0) {
            this.$router.replace(this.$route.query.redirect || "/");
             this.acquireVerification ()
          } else {
            this.$toast.fail(res.msg);
             this.acquireVerification ()
          }
        })
        .catch((res) => {
          this.$toast.fail(res.msg);
          console.log(res);
           this.acquireVerification ()
        });
    },
    submitByCode() {
      if (this.loginForm.mobile == "") {
        this.$toast.fail("请输入手机号");
        return;
      }
      if (this.loginForm.code == "") {
        this.$toast.fail("请输入动态验证码");
        return;
      }
      if (this.loginForm.checkCode == "") {
        this.$toast.fail("请输入图形验证码");
        return;
      }
      this.login({
        // vm: this,
        mobile: this.loginForm.mobile,
        password: this.loginForm.password,
        randomString:this.loginForm.checkCode,
        uuids:this.loginForm.uuid,
        state:1,
        VerificationCode:this.loginForm.code
      })
        .then((res) => {
          if (res.code == 0) {
            this.$router.replace(this.$route.query.redirect || "/");
             this.acquireVerification ()
          } else {
            this.$toast.fail(res.msg);
             this.acquireVerification ()
          }
        })
        .catch((res) => {
          this.$toast.fail(res.msg);
          console.log(res);
           this.acquireVerification ()
        });
    },
    // 发送验证码
    sendCode(type) {
      if(this.formReg.choosePwd=='输入密码'){
        if (typeof this.regSendCodeText == "number") {
        //判断是否在60秒内再次点击了获取动态码
        this.$toast.fail(
          "请在" + this.regSendCodeText + "秒后再次尝试获取动态码"
        );
        return;
      }
      console.log(55);
      axios
        .post("api/accountLogin/sendCode", {
          mobile: Number(this.formReg.username),
          state:0
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            this.$toast.fail(res.msg);
            return;
          }
          this.regSendCodeText = 60;
          let timer = setInterval(() => {
            //倒计时60
            console.log(this.regSendCodeText);
            this.regSendCodeText--;
            if (this.regSendCodeText <= 0) {
              //恢复为获取动态码
              clearInterval(timer);
              this.regSendCodeText = "获取动态码";
            }
          }, 1000);
        })
        .catch((err) => {
          this.$toast.fail(err.msg);
          console.log(err);
        });
      }else  if(this.formReg.choosePwd=='随机密码'){
        if (typeof this.regSendCodeTextTwo == "number") {
        //判断是否在60秒内再次点击了获取动态码
        this.$toast.fail(
          "请在" + this.regSendCodeTextTwo + "秒后再次尝试获取动态码"
        );
        return;
      }
      console.log(55);
      axios
        .post("api/accountLogin/sendCode", {
          mobile: Number(this.formReg.username),
          state:0
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            this.$toast.fail(res.msg);
            return;
          }
          this.regSendCodeTextTwo = 60;
          let timer = setInterval(() => {
            //倒计时60
            console.log(this.regSendCodeTextTwo);
            this.regSendCodeTextTwo--;
            if (this.regSendCodeTextTwo <= 0) {
              //恢复为获取动态码
              clearInterval(timer);
              this.regSendCodeTextTwo = "获取动态码";
            }
          }, 1000);
        })
        .catch((err) => {
          this.$toast.fail(err.msg);
          console.log(err);
        });
      }
    },
    // 登录验证码
    sendCode2() {
      if (typeof this.regSendCodeLogin == "number") {
        //判断是否在60秒内再次点击了获取动态码
        this.$toast.fail(
          "请在" + this.regSendCodeLogin + "秒后再次尝试获取动态码"
        );
        return;
      }
      console.log(55);
      axios
        .post("api/accountLogin/sendCode", {
          mobile: Number(this.loginForm.mobile),
          state:1    //登录是1，注册是0
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            this.$toast.fail(res.msg);
            return;
          }
          this.regSendCodeLogin = 60;
          let timer = setInterval(() => {
            //倒计时60
            console.log(this.regSendCodeLogin);
            this.regSendCodeLogin--;
            if (this.regSendCodeLogin <= 0) {
              //恢复为获取动态码
              clearInterval(timer);
              this.regSendCodeLogin = "获取动态码";
            }
          }, 1000);
        })
        .catch((err) => {
          this.$toast.fail(err.msg);
          console.log(err);
        });
    },
    sendCode1(){
      if(typeof this.regSendCodeText == 'number'){//判断是否在60秒内再次点击了获取动态码
        this.$toast.fail('请在' + this.regSendCodeText + '秒后再次尝试获取动态码')
        return
      }
      console.log(55)
      axios
        .post("api/accountLogin/sendCode", {
          mobile: Number(this.forgetForm.mobile)
        })
        .then(res => {
          console.log(res)
          if(res.code != 0){
            this.$toast.fail(res.msg)
            return
          }
          this.regSendCodeText = 60
          let timer = setInterval(()=>{//倒计时60
            console.log(this.regSendCodeText)
            this.regSendCodeText --
            if(this.regSendCodeText<=0){//恢复为获取动态码
              clearInterval(timer)
              this.regSendCodeText = '获取动态码'
            }
          },1000)
        })
        .catch(err=>{
          this.$toast.fail(err.msg)
          console.log(err)
        })
    },
    //用户注册
   //用户注册
    register() {
      console.log("注册开始");
      if (this.formReg.code == "") {
        this.$toast.fail("请输入验证码");
        return;
      }
      if(this.formReg.choosePwd=='输入密码'){
        if (this.formReg.password != this.formReg.password1) {
          this.$toast.fail("请保证两次输入密码一致");
          return;
        }
      }
      if (!this.formReg.checked) {
        this.$toast.fail("请勾选《用户注册协议》和《隐私政策声明》");
        return;
      }
      // changePasswordByCode
      let key = CryptoJS.enc.Utf8.parse("z1ijn$dk89dl#ers");
      let srcs = CryptoJS.enc.Utf8.parse(this.formReg.password);
      let iv = CryptoJS.enc.Utf8.parse("12abtrefgabcdefg");
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: iv,
      });
      let password = encodeURIComponent(encrypted.toString());
      axios.post("api/accountLogin/createAccount", {
          mobile: this.formReg.username,
          password: decodeURIComponent(password),
          state:0,
          code: this.formReg.code,
          uuids:this.formReg.uuids,
          inviteId: this.$route.query.inviteId ? this.$route.query.inviteId : "",
        })
        .then((res) => {
          if (res.code == 0) {
            this.$toast.loading({
              duration: 3000, // 持续展示 toast
              forbidClick: true,
              message:
                "注册申请已经提交，请等待工作人员审核，注意接听工作人员回访电话",
            });
            this.loginForm.mobile = this.formReg.username;
            this.isLogin = true;
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          this.$toast.fail(err.msg);
        });
    },
    // 用户注册随机密码
        //用户注册
    registerTwo() {
      console.log("注册开始");
      if (this.formReg.code == "") {
        this.$toast.fail("请输入验证码");
        return;
      }
      // if(this.formReg.choosePwd=='输入密码'){
      //   if (this.formReg.password != this.formReg.password1) {
      //     this.$toast.fail("请保证两次输入密码一致");
      //     return;
      //   }
      // }
      if (!this.formReg.checked) {
        this.$toast.fail("请勾选《用户注册协议》和《隐私政策声明》");
        return;
      }

      // changePasswordByCode
      let key = CryptoJS.enc.Utf8.parse("z1ijn$dk89dl#ers");
      let srcs = CryptoJS.enc.Utf8.parse(this.formReg.password);
      let iv = CryptoJS.enc.Utf8.parse("12abtrefgabcdefg");
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: iv,
      });
      let password = encodeURIComponent(encrypted.toString());
      axios.post("api/accountLogin/createAccount", {
          mobile: this.formReg.username,
          password: decodeURIComponent(password),
          state:1,
          code: this.formReg.code,
          uuid:this.formReg.uuids,
          inviteId: this.$route.query.inviteId
            ? this.$route.query.inviteId
            : "",
        })
        .then((res) => {
          if (res.code == 0) {
            this.$toast.loading({
              duration: 3000, // 持续展示 toast
              forbidClick: true,
              message:
                "注册申请已经提交，请等待工作人员审核，注意接听工作人员回访电话",
            });
            this.loginForm.mobile = this.formReg.username;
            this.isLogin = true;
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          this.$toast.fail(err.msg);
        });
    },
    //重置密码
    resetPwd(){
      // changePasswordByCode
      let key = CryptoJS.enc.Utf8.parse("z1ijn$dk89dl#ers");
      let srcs = CryptoJS.enc.Utf8.parse(this.forgetForm.password);
      let iv  = CryptoJS.enc.Utf8.parse("12abtrefgabcdefg");
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.CBC,padding: CryptoJS.pad.Pkcs7,iv:iv});
      let password = encodeURIComponent( encrypted.toString() );
       axios
        .post("api/accountLogin/changePasswod", {
          mobile: this.forgetForm.mobile,
          newPassword:  decodeURIComponent(password),
          code: this.forgetForm.code
        })
        .then(res => {
          if(res.code == 0){
            this.$toast.success('密码修改成功')
            this.loginForm.mobile = this.forgetForm.mobile
            this.isLogin = true
            this.forgetPwd = false
          }else{
            this.$toast.fail(res.msg);
          }
        })
        .catch(err=>{
          console.log(err)
          this.$toast.fail(err.msg);
        })
    } ,
    // 登录验证码
    acquireVerification () {
      axios
        .post("api/accountLogin/sendCaptcha", {
          responseType:  'blob',
        }).then((res)=>{
          if(res.code==0){
            console.log("res",res)
          // this.img = window.URL.createObjectURL(res.t)
          this.img =res.t.img;
          this.loginForm.uuid = res.t.uuid;
          this.loginFormTwo.uuid = res.t.uuid;
          this.formReg.uuids=res.t.uuid
          }else {
            this.$toast.fail(res.msg);
          }
        })
    },
    gotoDetail(i){
      //查看隐私协议
      var urlInfo =''
      this.setIndex = i
      if(i == 1){ //隐私政策
        urlInfo = "https://fdoc.oss-cn-shenzhen.aliyuncs.com/test/%E5%A4%A9%E6%BA%90%E9%9A%90%E7%A7%81%E5%A3%B0%E6%98%8E.docx";
      }else{//会员协议
        urlInfo = "https://fdoc.oss-cn-shenzhen.aliyuncs.com/test/%E6%B3%A8%E5%86%8C%E7%94%A8%E6%88%B7%E5%A3%B0%E6%98%8E%EF%BC%88%E5%B8%8C%E6%9C%9B%E5%A4%A9%E6%BA%90%EF%BC%89.docx";
      }
      // window.open(urlInfo, "_blank");
      this.getWordText(urlInfo)
    },
    getWordText(url) {
      const xhr = new XMLHttpRequest();
      xhr.open("get", url, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = () => {
        if (xhr.status == 200) {
          mammoth.convertToHtml({ arrayBuffer: new Uint8Array(xhr.response) }).then((resultObject) => {
            this.$nextTick(() => {
              this.userBool = true;
              this.wordText = resultObject.value;
            });
          });
        }
      };
      xhr.send();
    },
  },
}
</script>

<style lang="scss">
.login{
  width: 100%;
  height: 100%;
  background: #fff;
  .bg{
    position: relative;
    img{
      width: 100%;
    }
    .login-reg{
      position: absolute;
      width: 3rem;
      left: 50%;
      // top: 45%;
      // transform: translate(-50%,-50%);
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 100;

      .logo{
        font-size: .4rem;
        color: #fff;
        display: flex;
        justify-content: center;
        img{
          width: .7rem;
          height: 0.37rem;
        }
      }
      .btns{
        width: 2.25rem;
        height: .4rem;
        background:rgba(0,211,133,0.5);
        color: #fff;
        font-size: .16rem;
        display: flex;
        justify-content: space-between;
        border-radius:.22rem;
        margin-top: .3rem;
        .btn{
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family:PingFangSC-Medium,PingFang SC;
          &.active{
            background:linear-gradient(174deg,rgba(0,231,178,1) 0%,rgba(0,211,133,1) 100%);
            border-radius: .19rem;
          }
        }
      }
      .container-box{
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 14px 4px rgba(129,129,129,0.11);
        border-radius:.18rem;
        margin-top: .23rem;
        padding: 15px;
        box-sizing: border-box;
        width: 100%;
        .box{
          display: flex;
          flex-direction: column;
          align-items: center;;
          .title{
            font-size:.16rem;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(0,211,133,1);
            text-align: center;
            position: relative;
            height: .35rem;
            line-height: .35rem;
            margin-bottom: .18rem;
          }
          .title:after{
              width:23px;
              height:1px; 
              position: absolute;
              z-index: 0;
              left: 50%;
              transform: translateX(-50%);
              bottom: 0;
              content: "";
              background: #00D385;
          }
          .form{
            width: 100%;
            display: flex;
            flex-direction: column;
            .item{
              width:100%;
              height:.3rem;
              background:rgba(250,250,250,1);
              border-radius: .06rem;
              margin-bottom: 10px;
              display: flex;
              input{
                width: 100%;
                background: rgba(250,250,250,1);
                border: 0;
                border-radius:.18rem;
                padding-left: 10px;
                box-sizing: border-box;
                font-size: 12px;
              }
              &.code{
                .getCode{
                  width: 1rem;
                  font-size:12px;
                  color:rgba(102,102,102,1);
                  font-weight: 500;
                  display: flex;
                  align-items: center;
                }
              }
            }
          }
          .check{
            height: 40px;
            display: flex;
            align-items: center;
            .check-box{
              width: 15px;
              flex-shrink: 0;
              height: 15px;
            }
            .text{
              font-size: .08rem;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(153,153,153,1);
              padding-left: 5px;
              box-sizing: border-box;
              transform: scale(.9); transform-origin: left
              // transform: scale(0.83);
            }
          }
          .syb-btn{
            width:229px;
            height:36px;
            background:rgba(0,211,133,1);
            border-radius:18px;
            font-size:14px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: auto;
            margin-top: 10px;
          }
          .logintype{
            // height: 30px;
            display: flex;
            // line-height: 30px;
            margin-bottom: 10px;
            
            width: 100%;
            .btn{
              font-size:16px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(51,51,51,1);
              width: 50%;
              display: flex;
              justify-content: center;
              position: relative;
              padding-bottom: 10px;
              &.active{
                color:rgba(0,211,133,1);
              }
              &.active:after{
              width:23px;
              height:1px; 
              position: absolute;
              z-index: 0;
              left: 50%;
              transform: translateX(-50%);
              bottom: 0;
              content: "";
              background: #00D385;
          }

            }
          }
        }
      }
    }
  }
  .beian{
    position: fixed;
    bottom: 10px;
    width: 100%;
    font-size: 12px;
    z-index: 0;
    p{
      text-align: center;
      line-height: 20px;
      color: #999;
    }
  }
}
.userBox{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, .5);
  .userCenter{
    width: 86%;
    overflow: hidden;
    border-radius: 8px;
    position: absolute;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    padding-bottom: 20px;
    
    #wordView{
      font-size: 12px;
      line-height: 21px;
      padding:20px 10px;
      max-height: 50vh;
      overflow: hidden;
      overflow-y: auto;
    }
    .title{
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      padding-top: 15px;
      padding-bottom: 10px;
    }
    .btn{
      text-align: center;
      font-size: 12px;
      padding: 11px;
      color: #1989fa;
      background: #00d385;
      color: #fff;
      width: 80%;
      margin: auto;
      margin-top: 20px;
      border-radius: 8px;
    }
  }
}
</style>
